<template>
<footer class="footer">
  <div class="container">
    <div class="footer-container">

      <!-- اليمين -->
      <div class="footer-right">
        <img src="../assets/images/main-logo.svg" alt="Infinity Design Logo" class="footer-logo">
        <p class="footer-description">خيارك الأفضل لتعلم العلوم و الجيولوجيا</p>
      </div>

      <!-- النص -->
      <div class="footer-center">
        <h3 class="footer-title">روابط الصفحة</h3>
        <ul class="footer-links">
          <li>
            <router-link to="/" :class="{ 'active-link': $route.path === '/' || $route.path === '/home' }">الرئيسية</router-link>
          </li>
          <li><router-link to="/courses" exact-active-class="active-link">الكورسات</router-link></li>
          <li><router-link to="/exams" exact-active-class="active-link">الامتحانات</router-link></li>
          <li><router-link to="/homework" exact-active-class="active-link">الواجبات</router-link></li>
          <!-- <li><router-link to="/notes" exact-active-class="active-link">المذكرات</router-link></li> -->
        </ul>
      </div>

      <!-- الشمال -->
      <div class="footer-left">
        <h3 class="footer-title">تطوير شركة Infinity Design</h3>
          <ul>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FF9A18 " class="bi bi-globe" viewBox="0 0 16 16">
                <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"/>
              </svg>
              <a href="http://infinityfordesign.com/" target="_blank">http://infinityfordesign.com/</a>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FF9A18 " class="bi bi-telephone-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
              </svg>
              <a href="tel:+201118500056">+201118500056</a>
            </li>
            <li class="location">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FF9A18 " class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
              </svg>
              <div class="location-links">
                <a href="https://www.google.com/maps/place/Infinity+Design/@30.0444196,31.2357116,15z/data=!4m2!3m1!1s0x0:0x0" target="_blank">Egypt - Mansoura - Elteraa St. - Elbahey Tower</a>
                <a href="https://www.google.com/maps/place/Infinity+Design/@30.0444196,31.2357116,15z/data=!4m2!3m1!1s0x0:0x0" target="_blank">Saudi Arabia - Riyadh - Co Work Virtual Office</a>
              </div>
            </li>
          </ul>
      </div>
    </div>

    <!-- الحقوق -->
    <div class="footer-bottom">
      <p>جميع الحقوق محفوظة لـمستر أحمد مكاوي © 2025</p>
    </div>
  </div>
</footer>
</template>

<style>
.footer {
  background: #fff;
  color: #7F8685;
  padding: 40px 20px;
  direction: rtl;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  flex-wrap: wrap;
}

.footer-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 220px;
}
.footer-logo {
  max-width: 250px;
  width: 100%;
}
.footer-description {
  font-size: 16px;
  font-weight: 500;
  padding-top: 12px;
  text-align: center;
  color: #7F8685;
}

/* النص */
.footer-center {
  flex: 2;
  text-align: center;
  min-width: 250px;
}
.footer-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #000;
  text-align: center;
}
.footer-links {
  list-style: none;
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  padding: 0;
}
.footer-links li a {
  color: #7F8685;
  font-size: 15px;
  font-weight: 500;
  text-decoration: underline;
  transition: color 0.3s;
}
.footer-links li a:hover {
  color: #FF9A18;
}

.footer-left {
  flex: 1;
  min-width: 220px;
}
.footer-left ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.footer-left ul li {
  display: flex;
  align-items: flex-start;
  gap: 25px;
}
.footer-left ul li a {
  color: #7F8685;
  font-size: 14px;
  line-height: 1.4;
}
.location-links {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.footer-bottom {
  margin-top: 30px;
}
.footer-bottom p {
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #7F8685;
}

@media(max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  .footer-left ul li {
    justify-content: center;
    text-align: center;
  }
  .footer-right, .footer-left , .footer-center {
    width: 100%;
  }
  .footer-left ul{
    align-items: flex-start;
  }
}
</style>
